import {MultiForm, useMultiFormContext} from "../../../../../Common/components/MultiForm";
import NextOfKin from "./NextOfKin";
import React from "react";
import {combineMultiFormData} from "../../../../../../util/Helpers";
import TrustPerson from "./TrustPerson";
import {Button} from "react-bootstrap";

export function TrustInformation(
    {
        dataKey,
        initialValues,
        updateKYC,
        isUpdating,
        isEditable,
        isRequired
    }
) {
    const {upsertValue} = useMultiFormContext()
    const {userGroup, userId} = initialValues

    const sections = [
        {title: "Next of Kin", key: "nextOfKin", Component: NextOfKin},
        {title: "Trust Person", key: "trustInfo", Component: TrustPerson},
    ]

    const submit = (values) => {
        values = {trustData: combineMultiFormData(values).data}
        values.userGroup = userGroup
        values.userId = userId
        values.meta = initialValues
        updateKYC(values)
    }

    return <MultiForm
        onChange={
            (values) => upsertValue(
                dataKey,
                isRequired
                    ? combineMultiFormData(values)
                    : {isValid: true}
            )
        }
    >
        {
            ({isDirty, isValid, values}) => (
                <>
                    {
                        sections.map(({key, title, Component}) => (
                            <span key={key}>
                                <Component
                                    dataKey={key}
                                    title={title}
                                    initialValues={initialValues}
                                    isEditable={isEditable}
                                />
                                <div className={"my-2"}/>
                            </span>
                        ))
                    }
                    {
                        (isDirty && isEditable) && <Button
                            onClick={() => submit(values)}
                            variant={"dark"}
                            className={`w-100 position-sticky bottom-0 zindex-1 mt-2`}
                            disabled={!isValid || isUpdating}
                        >
                            Apply Changes
                        </Button>
                    }
                </>
            )
        }
    </MultiForm>
}